import type { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';

export const DICTIONARIES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./dictionaries/dictionaries.component').then(
        (m) => m.DictionariesComponent,
      ),
    canActivate: [permissionGuard('dictionaries.get')],
  },
];
